import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Cropper from 'react-easy-crop';
import { MediaModal } from '@tribeplatform/react-components/MediaModal';
import { Button, ButtonGroup } from '@tribeplatform/react-ui-kit/Button';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
const MAX_SMALL_DEVICE_WIDTH = 600; // this includes tablets too
export const BannerReposition = ({ banner, save, cancel, edit = false, children, loading }) => {
    var _a;
    const [preview, setPreview] = useState(false);
    const containerRef = useRef();
    const [cropSize, setCropSize] = useState();
    const [crop, setCrop] = useState({
        x: (banner === null || banner === void 0 ? void 0 : banner.cropX) || 0,
        y: (banner === null || banner === void 0 ? void 0 : banner.cropY) || 0,
    });
    // update on banner change
    useEffect(() => {
        var _a;
        if (banner === null || banner === void 0 ? void 0 : banner.id) {
            if (((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) <= MAX_SMALL_DEVICE_WIDTH)
                setCrop({ x: 0, y: 0 });
            else
                setCrop({
                    x: (banner === null || banner === void 0 ? void 0 : banner.cropX) || 0,
                    y: (banner === null || banner === void 0 ? void 0 : banner.cropY) || 0,
                });
        }
    }, [banner === null || banner === void 0 ? void 0 : banner.cropY, banner.cropX, banner.id, setCrop]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "h-32 w-full lg:h-48 cursor-pointer overflow-hidden", ref: containerRef, onClick: e => {
                    if (!loading && !edit && e.target === containerRef.current) {
                        setPreview(true);
                    }
                }, children: [_jsx(Cropper, { image: ((_a = banner === null || banner === void 0 ? void 0 : banner.urls) === null || _a === void 0 ? void 0 : _a.large) || (banner === null || banner === void 0 ? void 0 : banner.url), crop: crop, zoom: (banner === null || banner === void 0 ? void 0 : banner.cropZoom) || 1, onCropChange: props => {
                            var _a, _b, _c;
                            if (((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) <= MAX_SMALL_DEVICE_WIDTH)
                                setCrop({ x: 0, y: 0 });
                            else {
                                // we should let this function handle the setCrop to maintain the responsiveness on the smaller devices
                                // Math.round to fix gql error  "Int cannot represent non-integer value: -0.125"
                                // when user drags banner all the way up or all the way down
                                setCrop({ x: Math.round(props.x), y: Math.round(props.y) });
                            }
                            // setting the cropper size on window-resize/crop resize
                            setCropSize({
                                height: (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight,
                                width: (_c = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth,
                            });
                        }, objectFit: "horizontal-cover", cropSize: cropSize, showGrid: false, style: {
                            cropAreaStyle: {
                                border: 'none',
                                boxShadow: 'none',
                            },
                        }, classes: {
                            containerClassName: edit
                                ? ''
                                : 'cursor-default pointer-events-none',
                        } }, void 0), loading && (_jsx("div", { className: "flex justify-center opacity-100 text-white text-2xl w-44 py-1.5 px-5 pointer-events-none absolute rounded-sm", style: {
                            background: 'rgba(0, 0, 0, 0.4)',
                            left: 'calc(50% - 90px)',
                            top: 'calc(50% - 10px)',
                        }, children: _jsx(SpinnerIcon, { className: "animate-spin" }, void 0) }, void 0)), edit && (_jsxs(_Fragment, { children: [_jsx("div", { className: "text-center opacity-100 text-white text-xs w-44 py-1.5 px-5 pointer-events-none absolute rounded-sm", style: {
                                    background: 'rgba(0, 0, 0, 0.4)',
                                    left: 'calc(50% - 90px)',
                                    top: 'calc(50% - 10px)',
                                }, children: "Drag image to reposition" }, void 0), _jsx("div", { className: "absolute bottom-5 right-5 z-10", children: _jsxs(ButtonGroup, { size: "sm", children: [_jsx(Button, { onClick: () => {
                                                setCrop({
                                                    x: banner.cropX,
                                                    y: banner.cropY,
                                                });
                                                cancel();
                                            }, children: "Cancel" }, void 0), _jsx(Button, { onClick: () => save(crop), children: "Save position" }, void 0)] }, void 0) }, void 0)] }, void 0)), !edit && children] }, void 0), _jsx(MediaModal, { isVisible: preview, onClose: () => setPreview(false), slides: [banner] }, void 0)] }, void 0));
};
//# sourceMappingURL=BannerReposition.js.map